import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiService, { handleError } from "../Common/ApiCommon/ApiService";

// Checkout order thunk
export const checkoutOrder = createAsyncThunk(
  "checkout/order",
  async (payload, {dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.post("/orders/checkout", payload);
      dispatch(allOrders());
      return response.order;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.error || errors.message);
    }
  }
);

// Get all orders thunk
export const allOrders = createAsyncThunk(
  "order/getAllOrderDetails",
  async (filterType, { rejectWithValue }) => {
    try {
      // if filterType exists, append as query param
      const url = filterType
        ? `/orders/filter_orders?filter_type=${filterType}`
        : `/orders`;

      const response = await apiService.get(url);
      return response.orders;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.error || errors.message);
    }
  }
);


// Get  orders details thunk
export const getOrdersDetails = createAsyncThunk(
  "order/getOrdersDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/orders/${id}`);
      return response.data;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.errors || errors.message);
    }
  }
);

export const updateRequestStatus = createAsyncThunk(
  "order/updateRequestStatus",
  async ({ id, status }, {dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.post(
        `/canteen_orders/update_request_status?id=${id}&status=${status}`
      );
       dispatch(allOrders());
      return response;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.error || errors.message);
    }
  }
);

export const createOrder = createAsyncThunk(
  "create/order",
  async (payload, {dispatch, rejectWithValue }) => {
    try {
      const response = await apiService.post("/canteen_orders", payload);
      dispatch(allOrders());
      console.log("respcreateorder",response);
      return response;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.error || errors.message);
    }
  }
);

const checkoutSlice = createSlice({
  name: "orders",
  initialState: {
    orders: [],
    loading: false,
    success: false,
    error: null,
    orderData: null, 
  },
  reducers: {
    resetCheckoutState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.orders = null;
      // state.orders = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Checkout Order
      .addCase(checkoutOrder.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(checkoutOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.orders = action.payload;
      })
      .addCase(checkoutOrder.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      // All Orders
      .addCase(allOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(allOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //  Orders details by id
      .addCase(getOrdersDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrdersDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.orderData = action.payload;
      })
      .addCase(getOrdersDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // order accept reject
      .addCase(updateRequestStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRequestStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateRequestStatus.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      // Checkout Order
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

  },
});

export const { resetCheckoutState } = checkoutSlice.actions;
export default checkoutSlice.reducer;
